import './styles.scss';
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useAuth } from 'reactfire';

export default function CMSLogin(props) {
  const { setSignedIn } = props;
  const auth = useAuth();
  const signInWithGoogle = () => {
    signIn(auth);
  }
  const signIn = async auth => {
    const provider = new GoogleAuthProvider();

    await signInWithPopup(auth, provider);
    setSignedIn(v => v + 1);
  }

  return (
    <div className='CMSLogin'>

      <button type="button" onClick={signInWithGoogle} className="login-with-google-btn" >
        Sign in with Google
      </button>
    </div>
  )
}
